import {
  BookWidgetBasicFaresField,
  BookWidgetFields,
  BookWidgetShopMilesField,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { PriceTypes, ShopTypes } from '../../constants/postData.constants';

export const getPriceType = (shopMilesField?: BookWidgetShopMilesField) => {
  return shopMilesField?.checked && !shopMilesField?.hide
    ? PriceTypes.AWARD
    : PriceTypes.REVENUE;
};
export const getShopType = (shopMilesField?: BookWidgetShopMilesField) => {
  return shopMilesField?.checked && !shopMilesField?.hide
    ? ShopTypes.MILES
    : ShopTypes.MONEY;
};
const isTripTypeMultiCity = (bookWidgetFields: BookWidgetFields) =>
  bookWidgetFields.tripTypesField.selectedTripType ===
  TripTypeOptions.MULTI_CITY;

export const isFlexibleDates = (bookWidgetFields: BookWidgetFields) => {
  // flexDate should be false if triptype is multicity
  if (isTripTypeMultiCity(bookWidgetFields)) return false;
  return (
    !bookWidgetFields.flexDatesField.hide &&
    bookWidgetFields.flexDatesField.checked
  );
};

export const isFlexibleAirport = (bookWidgetFields: BookWidgetFields) => {
  // flexAirport should be false if triptype is multicity
  if (isTripTypeMultiCity(bookWidgetFields)) return false;
  return (
    !bookWidgetFields.flexAirportsField.hide &&
    bookWidgetFields.flexAirportsField.checked
  );
};

export const getBestFareValue = (bookWidgetFields: BookWidgetFields) => {
  return !bookWidgetFields.bestFareOptionsField.hide
    ? bookWidgetFields.bestFareOptionsField.selectedBestFare
    : '';
};
export const getRefundableFareField = (bookWidgetFields: BookWidgetFields) => {
  return (
    !bookWidgetFields.refundableFareField.hide &&
    bookWidgetFields.refundableFareField.checked
  );
};
export const getMeetingEventCode = (bookWidgetFields: BookWidgetFields) => {
  return !bookWidgetFields.meetingEventCodeField.hide
    ? bookWidgetFields.meetingEventCodeField.meetingEventCodeValue
    : '';
};

export const formatDateString = (date: Date | null): string => {
  if (!date) return '';
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getIncludeBasicFaresUnchecked = (
  basicFaresField: BookWidgetBasicFaresField
) => {
  let includeBasicFaresUnchecked = false;

  if (!basicFaresField.hide && !basicFaresField.checked) {
    includeBasicFaresUnchecked = true;
  }

  return includeBasicFaresUnchecked;
};
